import httpClient from '../../httpClient';

const apiBaseUrl = 'super-admin/centsible';

export const getAllDevices = (pageNumber, searchTerm) => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/all`,
    params: {
      pageNumber,
      searchTerm,
    },
  });
};

export const fetchLogs = (mac) =>
  httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/logs/devices/${mac}`,
  });

export const fetchScreen = (mac) =>
  httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/frame-buffer/devices/${mac}`,
  });

export const sendDeviceCommand = (mac, action) =>
  httpClient({
    method: 'POST',
    url: `${apiBaseUrl}/commands/devices/${mac}`,
    data: {
      action,
    },
  });

export const uploadDevices = (params) => {
  return httpClient({
    method: 'POST',
    url: 'super-admin/devices',
    headers: {
      'content-type': 'multipart/form-data',
    },
    data: params,
  });
};

export const fetchIndividualDevice = (id) => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/${id}/find`,
  });
};

export const updateIndividualDevice = (id, data) => {
  return httpClient({
    method: 'PUT',
    url: `${apiBaseUrl}/devices/${id}/update`,
    data,
  });
};

export const getListOfPossibleDeviceStatuses = () => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/statuses`,
  });
};

export const simulateAllianceSerialDeviceInitialization = (data) => {
  return httpClient({
    method: 'POST',
    url: `${apiBaseUrl}/devices/simulator/alliance/initialization`,
    data,
  });
};

export const getMachineManufacturers = () => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/simulator/manufacturers`,
  });
};

export const getMachineControlTiers = ({ manufacturer, style }) => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/simulator/manufacturers/control-tiers`,
    params: {
      manufacturer,
      style,
    },
  });
};

export const getMachineSizesForManufacturer = (manufacturer, style) => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/simulator/manufacturers/sizes`,
    params: {
      manufacturer,
      style,
    },
  });
};

export const simulateDexterDeviceInitialization = (data) => {
  return httpClient({
    method: 'POST',
    url: `${apiBaseUrl}/devices/simulator/dexter/initialization`,
    data,
  });
};

export const getDexterModelsByMachineType = (machineType) => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/simulator/dexter/models`,
    params: {
      machineType,
    },
  });
};

export const retriggerInitialization = (id) => {
  return httpClient({
    method: 'POST',
    url: `${apiBaseUrl}/devices/${id}/reinitialize`,
  });
};

export const getTurnServiceTypes = () => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/simulator/run-machine/service-types`,
  });
};

export const simulateMachineDrivenDeviceTransaction = (data) => {
  return httpClient({
    method: 'POST',
    url: `${apiBaseUrl}/devices/simulator/run-machine/transaction/machine-driven`,
    data,
  });
};

export const simulateDeviceStatusEvent = (data) => {
  return httpClient({
    method: 'POST',
    url: `${apiBaseUrl}/devices/simulator/status`,
    data,
  });
};

export const getAllTeamMembersForBusiness = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/simulator/run-machine/transaction/full-cycle/business/${businessId}/team-members`,
  });
};

export const simulateTechnicalServiceDeviceTransaction = (data) => {
  return httpClient({
    method: 'POST',
    url: `${apiBaseUrl}/devices/simulator/run-machine/transaction/full-cycle/technical-service`,
    data,
  });
};

export const getAllCustomersForBusiness = (businessId) => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/simulator/run-machine/customer-service/business/${businessId}/customers`,
  });
};

export const simulateCustomerServiceDeviceTransaction = (data) => {
  return httpClient({
    method: 'POST',
    url: `${apiBaseUrl}/devices/simulator/run-machine/transaction/full-cycle/customer-service`,
    data,
  });
};

export const simulateLiveLinkDeviceTransaction = (data) => {
  return httpClient({
    method: 'POST',
    url: `${apiBaseUrl}/devices/simulator/run-machine/transaction/full-cycle/live-link`,
    data,
  });
};

export const fetchProcessingServiceOrdersPerStore = (storeId) => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/simulator/run-machine/transaction/full-cycle/store/${storeId}/service-orders`,
  });
};

export const simulateFullServiceDeviceTransaction = (data) => {
  return httpClient({
    method: 'POST',
    url: `${apiBaseUrl}/devices/simulator/run-machine/transaction/full-cycle/full-service`,
    data,
  });
};

export const fetchAvailableCyclesForDevice = (deviceId) => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/simulator/${deviceId}/cycles`,
  });
};

export const fetchAvailableModifiersForDevice = (deviceId) => {
  return httpClient({
    method: 'GET',
    url: `${apiBaseUrl}/devices/simulator/${deviceId}/modifiers`,
  });
};

export const retriggerInitializationForStores = (storeIds) => {
  return httpClient({
    method: 'POST',
    url: `common/devices/reinitialize/list`,
    data: storeIds,
  });
};

export const simulateElectroluxSerialDeviceInitialization = (data) => {
  return httpClient({
    method: 'POST',
    url: `${apiBaseUrl}/devices/simulator/electrolux/initialization`,
    data,
  });
};
